<template>
  <div class="Create alignment">
    <template>
      <v-flex xs12 sm12>
        <h3 v-if="edit" class="styleHeader">
          {{ $t("pages.Stock.Create.SitoModifica") }}
        </h3>
        <h3 v-else class="styleHeader">
          {{ $t("pages.Stock.Create.SitoAggiungi") }}
        </h3>
        <v-card class="styleDataTable">
          <form>
            <v-select
              v-model="databaseCodeSelected"
              :items="databaseCode"
              :label="$t('pages.Stock.Create.SelezionaDatabase')"
              item-text="databaseCode"
              required
              :error-messages="databaseCodeSelectedErrors"
              @change="
                $v.databaseCodeSelected.$touch();
                onDatabaseCodeChange($event);
              "
              @blur="$v.databaseCodeSelected.$touch()"
            ></v-select>
            <v-text-field
              v-model="name"
              :label="$t('pages.Stock.Create.Nome')"
              :error-messages="nameErrors"
              @input="$v.name.$touch()"
              @blur="$v.name.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="serverName"
              :label="$t('pages.Stock.Create.Server')"
              :disabled="true"
              :error-messages="serverNameErrors"
              @input="$v.serverName.$touch()"
              @blur="$v.serverName.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="dbName"
              :label="$t('pages.Stock.Create.Database')"
              :disabled="true"
              :error-messages="dbNameErrors"
              @input="$v.dbName.$touch()"
              @blur="$v.dbName.$touch()"
            ></v-text-field>
          </form>
        </v-card>
        <v-btn
          class="white--text styleButtonTop styleAlignementSaveButton"
          @click="submit"
          color="#279947"
        >
          <v-icon left>check_circle</v-icon>
          {{ $t("pages.Stock.Create.Salva") }}
        </v-btn>
        <v-btn class="styleButtonTop" @click="back()">
          <v-icon left>remove_circle</v-icon>
          {{ $t("pages.Stock.Create.Annulla") }}
        </v-btn>
      </v-flex>
      <v-alert :value="errorAlert" type="error" transition="scale-transition">
        {{ errorMessage }}
      </v-alert>
    </template>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import stocksApi from "../../apiSmartLogistics/stocksApi.js";
import router from "@/router/index.js";

import { Trans } from "@/plugins/Translation";
export default {
  mixins: [validationMixin],
  validations: {
    databaseCodeSelected: { required },
    dbName: { required, maxLength: maxLength(100) },
    serverName: { required, maxLength: maxLength(500) },
    name: { required, maxLength: maxLength(100) }
  },

  data: () => ({
    databaseCodeSelected: "",
    databaseCode: [],
    dbName: "",
    serverName: "",
    name: "",
    errorAlert: false,
    errorMessage: ""
  }),

  computed: {
    edit() {
      return this.$route.params.id;
    },
    dbNameErrors() {
      const errors = [];
      if (!this.$v.dbName.$dirty) return errors;
      !this.$v.dbName.required &&
        errors.push(this.currentLanguage.t("Validations.CampoObbligatorio"));
      return errors;
    },
    serverNameErrors() {
      const errors = [];
      if (!this.$v.serverName.$dirty) return errors;
      !this.$v.serverName.required &&
        errors.push(this.currentLanguage.t("Validations.CampoObbligatorio"));
      return errors;
    },
    databaseCodeSelectedErrors() {
      const errors = [];
      if (!this.$v.databaseCodeSelected.$dirty) return errors;
      !this.$v.databaseCodeSelected.required &&
        errors.push(this.currentLanguage.t("Validations.CampoObbligatorio"));
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required &&
        errors.push(this.currentLanguage.t("Validations.CampoObbligatorio"));
      return errors;
    },
    currentLanguage() {
      return Trans.i18n;
    }
  },

  created() {
    const id = this.$route.params.id;

    if (id) {
      stocksApi.GetStockInternal(id).then(response => {
        this.id = response.data.id;
        this.databaseCodeSelected = response.data.databaseCode;
        this.serverName = response.data.serverName;
        this.dbName = response.data.dbName;
        this.name = response.data.name;
        this.getStocks();
      });
    }

    this.getStocks();
  },
  methods: {
    getStocks() {
      stocksApi.GetStocks(this.databaseCodeSelected).then(response => {
        this.databaseCode = response.data;
      });
    },

    onDatabaseCodeChange() {
      var dbselected = this.databaseCodeSelected;
      var dbname = "";
      var servername = "";
      this.databaseCode.filter(function(ele) {
        if (ele.databaseCode == dbselected) {
          servername = ele.serverDNS;
          dbname = ele.databaseName;
        }
      });

      this.dbName = dbname;
      this.serverName = servername;
    },

    back() {
      router.push({ name: "StocksIndex" });
    },

    submit() {
      this.$v.$touch();
      const route_id = this.$route.params.id;
      if (
        this.$v.databaseCodeSelected.$error ||
        this.$v.name.$error ||
        this.$v.serverName.$error ||
        this.$v.dbName.$error
      ) {
        return;
      }

      let stock = {
        id: route_id,
        databaseCode: this.databaseCodeSelected,
        dbName: this.dbName,
        serverName: this.serverName,
        name: this.name
      };

      if (route_id) {
        stocksApi
          .UpdateStock(stock)
          .then(() => {
            router.push({ name: "StocksIndex" });
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      } else {
        stocksApi
          .AddStock(stock)
          .then(() => {
            router.push({ name: "StocksIndex" });
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      }
    },
    clear() {
      this.$v.$reset();
      this.databaseCodeSelected = "";
      this.dbName = "";
      this.name = "";
      this.serverName = "";
    }
  }
};
</script>
